import { createSearchParams } from "react-router-dom";
import { InputValidation } from "../models/InputValidation";
import { CommonTexts as Texts } from "./LayoutTexts";

export function validateEmail(email: string): boolean {
    const emailRegex = /\S+@\S+\.\S+/;    
    return emailRegex.test(email);
}

export const validatePhoneNumber = (number: string) => {
    //Valid numbers : +947********, 947********, +9407********, 9407********, 07********, 7********
    let regex = /^(?:\+94|94|\+940|940|0)?(7\d{8})$/;  
    return regex.test(number);  
}

export const getWhatsAppFormatNumber = (number: string) : string => {
    let whatsAppFormatNumber: string = "";
    let regex = /^(?:\+94|94|\+940|940|0)?(7\d{8})$/;  
    if(regex.test(number)) {
        whatsAppFormatNumber = "94" + number.substring(number.length - 9);
    }
    return whatsAppFormatNumber;
}

export const getSeoName = (value: string) => {    
    return value
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-')     // Replace spaces with hyphens
    .trim();                  // Trim any leading/trailing spaces
}

export const getFormatedDate = (date: Date | string, excludeYear?: boolean ) => {
    if (date) {
        let formatedDate: string = "";
        if(excludeYear) {        
            formatedDate = new Date(date).toLocaleDateString("en-us", {                
                month: "long",
                day: "numeric"
            });
        }
        else {
            formatedDate = new Date(date).toLocaleDateString("en-us", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        }
        return formatedDate;
    }
};

export const getFormatedTime = (time24: string): string => {
    const [hoursStr, minutesStr] = time24.split(':');
    let hours = parseInt(hoursStr);
    const minutes = parseInt(minutesStr);
    const ampm = hours >= 12 ? 'PM' : 'AM';
  
    hours = hours % 12;
    hours = hours ? hours : 12; // The hour '0' should be '12'
  
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
  
    return `${hours}:${formattedMinutes} ${ampm}`;
};

export const getFormatedTimeFromDate = (date: Date | string, in12Hour?: boolean): string => {
    const formattedTime = new Date(date).toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: in12Hour, // Enables 12-hour format
    });
    return formattedTime;
};

export const validatePDF = (file: File) : InputValidation => {        
    const validFileTypes = ['application/pdf'];
    let pdfValidation: InputValidation = {valid: true};        
    if (!validFileTypes.includes(file.type)) {
        pdfValidation = {valid: false, invalid: true, invalidMessage: "Invalid file format. Try pdf format"};
    } 
    else if (file.size <= 0) {
        pdfValidation = {valid: false, invalid: true, invalidMessage: "File upload was not successful. Please try again"};
    }
    return pdfValidation;
}

export const getClassWeekPaymentSlipUrl = (weekId: number, adminId: number, token: string) => {
    let params = { weekId: weekId.toString(), adminId: adminId.toString(), token: token };
    return Texts.apiBaseUrl + "online-classes/week-pay-slip-by-admin?" + createSearchParams(params);
}

export const validateVideo = (file: File) : InputValidation => {
    const validFileTypes = ['video/mp4'];
    let videoValidation: InputValidation = {valid: true};
    if (!validFileTypes.includes(file.type)) {
        videoValidation = {valid: false, invalid: true, invalidMessage: "Invalid video format. Try mp4 format"};
    }
    else if (file.size <= 0) {
        videoValidation = {valid: false, invalid: true, invalidMessage: "File upload was not successful. Please try again"};
    }
    return videoValidation;
}

// Opened directly by the browser, so the token goes in the query string
export const getVideoLessonTuteUrl = (lessonId: number, adminId: number, token: string) => {
    let params = { lessonId: lessonId.toString(), adminId: adminId.toString(), token: token };
    return Texts.apiBaseUrl + "video-lessons/tute-by-admin?" + createSearchParams(params);
}

// Opened directly by the browser, so the token goes in the query string
export const getVideoPayoutSlipUrl = (payoutId: number, adminId: number, token: string) => {
    let params = { payoutId: payoutId.toString(), adminId: adminId.toString(), token: token };
    return Texts.apiBaseUrl + "video-lessons/payout-slip-by-admin?" + createSearchParams(params);
}

// Bank transfer slips come as a pdf or a screenshot/photo
export const validatePaySlip = (file: File) : InputValidation => {
    let slipValidation: InputValidation = {valid: true};
    if (file.type !== 'application/pdf' && !file.type.startsWith('image/')) {
        slipValidation = {valid: false, invalid: true, invalidMessage: "Invalid file format. Try pdf or an image"};
    }
    else if (file.size <= 0) {
        slipValidation = {valid: false, invalid: true, invalidMessage: "File upload was not successful. Please try again"};
    }
    return slipValidation;
}

export const formatAmount = (amount: number) : string => {
    return "LKR " + amount.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// yyyy-mm-dd of the last day of the previous month, in local time (the default payout cut-off)
export const getLastMonthEndDate = () : string => {
    const today = new Date();
    const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
    const month = (lastMonthEnd.getMonth() + 1).toString().padStart(2, "0");
    const day = lastMonthEnd.getDate().toString().padStart(2, "0");
    return `${lastMonthEnd.getFullYear()}-${month}-${day}`;
}

export const getLanguageCode = () : string => {
    if (localStorage.getItem('languageCode') === null) {
        localStorage.setItem('languageCode', "SIN");   
        return "SIN";
    }
    else {
        return localStorage.getItem('languageCode')!;
    }
}